<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Request Record Attachment Form</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-textarea
                outlined
                label="Message"
                placeholder="Leave a message for the Records Officer"
                v-model="message"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close(false)">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="save()">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "RouteRequestDialog",
  props: {
    dialog: Boolean,
    routeId: Number,
    routeType: String,
  },
  data() {
    return {
      message: "",
    };
  },
  methods: {
    ...mapActions(["sendRouteRequest"]),
    close(val) {
      this.message = "";
      this.$emit("closeDialog", val);
    },
    save() {
      const body = {
        route_id: this.routeId,
        route_type: this.routeType,
        message: this.message,
      };

      this.sendRouteRequest(body).then((result) => {
        if (result) {
          result.type = this.routeType;
          Swal.fire(
            "Request Sent!",
            "The record attachment you requested has been delivered",
            "success"
          );
          this.close(result);
        }
      });
    },
  },
};
</script>

<style scoped></style>
